// src/utils/request.ts
import { request } from '@umijs/max';
import { getSessionCookie } from './cookie';

const wrapperRequest = async <T>(url: string, options: any = {}): Promise<T> => {
  try {
    const sessionId = getSessionCookie();
    const res = await request<T>(url, {
      baseURL: BASE_URL,
      credentials: 'include',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionId,
        ...(options.headers || {}),
      },
    });
    return res as T;
  } catch (error: any) {
    if (!error.response) {
      console.error('Network error', error);
      throw error;
    }
    const { status } = error.response;
    if (status === 401) {
    }
    throw error;
  }
};

export default wrapperRequest;
